import ErrorPage from './container';

export default ErrorPage;
